<script setup lang="ts">
import { Modal, Form } from 'ant-design-vue';

import InputButton from '@/ui/InputButton.vue';
import type { FileContentFragmentFragment, FileFragmentFragment } from '@/graphql/generated/graphql';

export type FileContentValue = FileContentFragmentFragment;

defineProps<{
  file: FileFragmentFragment;
}>();

const fileContent = defineModel<FileContentValue | undefined>('value');
const visible = defineModel<boolean>('visible');

const formItemContext = Form.useInjectFormItemContext();

const onSelect = (record?: FileContentFragmentFragment) => {
  visible.value = false;
  fileContent.value = record;
  formItemContext.onFieldChange();
};

const onRemove = () => {
  fileContent.value = undefined;
  formItemContext.onFieldChange();
};
</script>

<template>
  <div>
    <InputButton
      :on-click="() => visible = true"
      :on-remove="onRemove"
      :show-remove="!!fileContent"
      data-testid="file-content-input-button"
    >
      <template v-if="fileContent">
        File content #{{ fileContent.id }}
      </template>
      <span v-else class="opacity-30">
        Select file content
      </span>
    </InputButton>
    <Modal
      :open="visible"
      width="80%"
      title="Select file content"
      :footer="false"
      @cancel="() => visible = false"
    >
      <FileContentServiceTable
        ref="tableRef"
        :key="fileContent ? `file-content-${fileContent.id}` : 'no-file-content'"
        :file="file"
        :set-url="false"
        :on-select="onSelect"
      />
    </Modal>
  </div>
</template>